// Maps a duration (seconds) to a "health" tier relative to the account's SLA
// target. Used to colour first-response numbers and per-country bars.
//
// Tiers:
//   - good: within SLA
//   - warn: between 1× and 3× SLA
//   - bad:  greater than 3× SLA
//   - none: no data
export type SlaTier = 'good' | 'warn' | 'bad' | 'none'

export function slaTier(seconds: number | null | undefined, slaSeconds: number): SlaTier {
  if (seconds == null) return 'none'
  if (seconds <= slaSeconds) return 'good'
  if (seconds <= slaSeconds * 3) return 'warn'
  return 'bad'
}

// SLA-hit-rate tier: a percentage between 0 and 1 (e.g. 0.85 = 85%).
export function slaRateTier(pct: number | null | undefined): SlaTier {
  if (pct == null) return 'none'
  if (pct >= 0.9) return 'good'
  if (pct >= 0.6) return 'warn'
  return 'bad'
}

// Tailwind text classes. Dark-first theme — these have explicit dark: variants
// only where the light-mode shade is too pale to read against the muted card
// background.
export const tierText: Record<SlaTier, string> = {
  good: 'text-emerald-500 dark:text-emerald-400',
  warn: 'text-amber-500 dark:text-amber-400',
  bad: 'text-rose-500 dark:text-rose-400',
  none: 'text-muted-foreground',
}

// Tailwind background classes for bars / pills.
export const tierBar: Record<SlaTier, string> = {
  good: 'bg-emerald-500 dark:bg-emerald-400',
  warn: 'bg-amber-500 dark:bg-amber-400',
  bad: 'bg-rose-500 dark:bg-rose-400',
  none: 'bg-muted',
}

// Border tints for outlined badges.
export const tierBorder: Record<SlaTier, string> = {
  good: 'border-emerald-500/50 dark:border-emerald-400/50',
  warn: 'border-amber-500/50 dark:border-amber-400/50',
  bad: 'border-rose-500/50 dark:border-rose-400/50',
  none: 'border-border',
}
